import { Component, OnInit } from '@angular/core';
import { AuthorizationService, Authority } from '@pwc-bei/security';
import { EAccessPlanVariable } from 'src/app/enum/access-plan-variable';
import { AuthorityCodeEnum } from 'src/app/enums/security/authority-code.enum';
import { AuthenticationUtilsService } from 'src/app/services/authentication-utils.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {
  authorities: AuthorityCodeEnum[] = [];
  userPlan: AuthorityCodeEnum[];
  isUserPlus: boolean = false;
  isUserSmart: boolean = false;

  constructor(
    public authorizationService: AuthorizationService,
    private authenticationUtilsService: AuthenticationUtilsService,
  ) {}

  ngOnInit(): void {
    this.initUserPlan();
  }

  initUserPlan(): void {
    if (environment.accessPlanEnabled) {
      this.authorizationService
        .getAuthorities()
        .subscribe((auths: Authority[]) => {
          const authorities: String[] = auths.map((a) => a.code);
          this.isUserSmart =
            authorities.filter(
              (a) => a.localeCompare('ROLE_BANDI_B2C_SMART') == 0,
            ).length > 0;
          this.isUserPlus =
            authorities.filter(
              (a) => a.localeCompare('ROLE_BANDI_B2C_PLUS') == 0,
            ).length > 0;
          this.authenticationUtilsService.setSessionVariable(
            EAccessPlanVariable.IS_USER_SMART,
            this.isUserSmart,
          );
          this.authenticationUtilsService.setSessionVariable(
            EAccessPlanVariable.IS_USER_PLUS,
            this.isUserPlus,
          );
          const isUserPremium = !(this.isUserPlus || this.isUserSmart);
          this.authenticationUtilsService.setSessionVariable(
            EAccessPlanVariable.IS_USER_PREMIUM,
            isUserPremium,
          );
        });
    } else {
      this.authenticationUtilsService.setSessionVariable(
        EAccessPlanVariable.IS_USER_PREMIUM,
        true,
      );
    }
  }
}
